module.exports = __webpack_public_path__ + "img/icn_aligned-left.86da40f2.svg";